export enum Permissions {
    MASTER = "serviceCentralMaster",
    ADMIN = "serviceCentralAdmin",
    MANAGER = "serviceCentralManager",
    USER = "serviceCentralUser"
}